module.exports = __webpack_public_path__ + "img/Rust-4.da1d7eda.png";